import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import OrderLinkBadge from "@js/vue/domain/invoice/components/shared/OrderLinkBadge.vue";
import { Folder, Tag } from 'lucide-vue-next';
import { groupOrders } from "@js/vue/domain/invoice/utils/invoice-grouping";
export default /*@__PURE__*/ _defineComponent({
    __name: 'InvoiceOrders',
    props: {
        orders: { type: Array, required: true },
        dataTrack: { type: String, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const groupedOrders = computed(() => groupOrders(props.orders));
        const __returned__ = { props, groupedOrders, OrderLinkBadge, get Folder() { return Folder; }, get Tag() { return Tag; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
